type dataProduct = {
  title: any;
  description: any;
  picture: string;
  images: any[];
  supplier_code: string;
  saleprice: number;
  category_id: number;
  brand_id: number;
  colours: string;
  size: string;
  weight: number;
  dimension_width: number;
  dimension_height: number;
  dimension_length: number;
  remote_stock: "T" | "F";
  remote_stock_duration_from: string;
  remote_stock_duration_to: string;
  sku_barcode: any[];
  returnable: "T" | "F";
  consumable: "T" | "F";
  need_freezer: "T" | "F";
  video: string;
  color_binding: string;
};

export function getUploadResult(data: dataProduct) {
  const content = {
    title: data.title,
    description: data.description,
    picture: data.picture,
    images: data.images,
    supplier_code: data.supplier_code,
    saleprice: data.saleprice,
    category_id: data.category_id,
    brand_id: data.brand_id,
    colours: data.colours,
    size: data.size,
    weight: data.weight,
    dimension_width: data.dimension_width,
    dimension_height: data.dimension_height,
    dimension_length: data.dimension_length,
    remote_stock: data.remote_stock,
    remote_stock_duration_from: data.remote_stock_duration_from,
    remote_stock_duration_to: data.remote_stock_duration_to,
    sku_barcode: data.sku_barcode,
    returnable: data.returnable,
    consumable: data.consumable,
    need_freezer: data.need_freezer,
    video: data.video,
    color_binding: data.color_binding,
  };

  return content;
}

export function SKU(data: any | undefined, colours: any[], size: any[]) {
  const sku: any[] = data === undefined ? [] : data;

  if (sku.length === 0 || sku === undefined) {
    if (colours.length > size.length) {
      for (let i = 0; i < colours.length; i++) {
        for (let j = 0; j < size.length; j++) {
          sku.push({
            color: colours[i],
            size: size[j],
            barcode: "",
          });
        }
      }
    } else {
      for (let i = 0; i < size.length; i++) {
        for (let j = 0; j < colours.length; j++) {
          sku.push({
            color: colours[j],
            size: size[i],
            barcode: "",
          });
        }
      }
    }
  }
  return sku;
}
